import {createSlice} from "@reduxjs/toolkit";
import {setUIInvoiceSearchFilter} from "./actions";
import {InvoiceSearchCriteria} from "@ots-frontend/ots-data";

type InvoiceUIState = {
  searchFilter?: InvoiceSearchCriteria
}

const INITIAL_STATE: Readonly<InvoiceUIState> = {};

const invoiceUISlice = createSlice({
  name: "ots-ui/invoice",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setUIInvoiceSearchFilter,
      (state, {payload}) => {
        state.searchFilter = payload
      }
    );
  }
});

export const invoiceUIReducer = invoiceUISlice.reducer;
